import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los pagos de chofer
// opcional: filtros { chofer, desde, hasta }
export const getPagochoferes = async (filtros = {}) => {
  const token = localStorage.getItem("token") || "";

  let url = `${BASE_URL}/pagochoferes`;

  const params = new URLSearchParams();

  if (filtros.chofer) params.append("chofer", filtros.chofer);
  if (filtros.desde) params.append("desde", filtros.desde);
  if (filtros.hasta) params.append("hasta", filtros.hasta);

  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener pagos de chofer",
    };
  }
};

// ✅ GET: Traer un pago de chofer por ID
export const getPagochoferById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/pagochoferes/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener pago de chofer",
    };
  }
};

// ✅ POST: Crear nuevo pago de chofer
export const postPagochofer = async (pagoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/pagochoferes`;

  try {
    const resp = await axios.post(url, pagoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear pago de chofer",
    };
  }
};

// ✅ PUT: Actualizar pago de chofer
export const putPagochofer = async (id, pagoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/pagochoferes/${id}`;

  try {
    const resp = await axios.put(url, pagoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar pago de chofer",
    };
  }
};

// ✅ DELETE: Anular pago de chofer
export const deletePagochofer = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/pagochoferes/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar pago de chofer",
    };
  }
};